import type { TagMessageType } from 'container/SalesOrder'
import type { ErrorMessage } from 'store/AuthContext/Types/authSliceType'

const HAVPhoneNumber = '(11) 3847-7477'

const errorMessages = {
  emptyField: 'Campo obrigatório',
  expiredLogin: 'Login expirado.',
  invalidField: 'Campo inválido',
  invalidTerm: 'Prazo Inválido',
}

const authRetCod = {
  deniedAccess: '1001',
  expiredPassword: '1007',
  inactiveUser: '1004',
  incompleteValidation: '99',
  incorrectCredentials: '1014',
  invalidUser: '1018',
  PasswordBlock1: '1015',
  PasswordBlock2: '1016',
  requireValidation: '0',
} as const

type DescriptionsRetCod = keyof typeof authRetCod
export type AuthRetCodKeys = (typeof authRetCod)[DescriptionsRetCod]

type AuthErrorsType = Record<AuthRetCodKeys, ErrorMessage>

const authErrors: AuthErrorsType = {
  [authRetCod.requireValidation]: {
    description: 'Autentique seu login usando o código enviado por email.',
    title: 'Confirmação necessária.',
  },
  [authRetCod.incompleteValidation]: {
    description: 'Autentique seu login usando o código enviado por email.',
    title: 'Confirmação pendente.',
  },
  [authRetCod.incorrectCredentials]: {
    description:
      'Caso insira a senha incorreta três vezes consecutivas, sua conta será automaticamente bloqueada. Para recuperar o acesso, será necessário redefinir sua senha.',
    title: 'Usuário ou senha incorretos.',
  },
  [authRetCod.expiredPassword]: {
    description:
      'Sua senha está expirada, você será redirecionado para uma página onde poderá atualizá-la',
    title: 'Senha expirada.',
  },
  [authRetCod.deniedAccess]: {
    description: 'Entre em contato com o backoffice para saber mais.',
    title: 'Acesso negado.',
  },
  [authRetCod.inactiveUser]: {
    description: 'Entre em contato com o backoffice para saber mais.',
    title: 'Conta desativada.',
  },
  [authRetCod.PasswordBlock1]: {
    description:
      'Sua senha foi inserida incorretamente três ou mais vezes consecutivas, por isso sua conta foi bloqueada.',
    title: 'Conta bloqueada.',
  },
  [authRetCod.PasswordBlock2]: {
    description:
      'Sua senha foi inserida incorretamente três ou mais vezes consecutivas, por isso sua conta foi bloqueada.',
    title: 'Conta bloqueada.',
  },
  [authRetCod.invalidUser]: {
    description: 'Entre em contato com o backoffice para saber mais.',
    title: 'Usuário não cadastrado.',
  },
} as const

const unknownError = () => {
  return {
    description: `Tente novamente ou ligue para ${HAVPhoneNumber}`,
    title: 'Erro desconhecido.',
  }
}

interface MTOTagsInterface {
  MTOCustomization: TagMessageType
  OUTLineFlag: TagMessageType
}
const MTOTags: MTOTagsInterface = {
  MTOCustomization: 'MTO - PREPARAÇÃO',
  OUTLineFlag: 'FORA DE LINHA',
}

const invalidEmailDomainError: ErrorMessage = {
  description: 'Não é permitido entrar com email com esse domínio. Troque o tipo de usuário.',
  title: 'Domínio de email inválido',
}

export {
  authErrors,
  authRetCod,
  errorMessages,
  HAVPhoneNumber,
  invalidEmailDomainError,
  MTOTags,
  unknownError,
}
